import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/tmp/gatsby/src/components/layout.js";
import SEO from '../components/seo.js';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <SEO title="Imprint" slug="en/impressum/" lang="en" mdxType="SEO" />
    <h1>{`Imprint`}</h1>
    <p>{`Information in accordance with Section 5 of the E-Commerce Act, Section 14 of the German Business Code, Section 63 of the Commercial Code and disclosure requirements under Section 25 of the Media Act
`}<a parentName="p" {...{
        "href": "https://firmen.wko.at/Web/DetailsKontakt.aspx?FirmaID=4a4f6192-1d16-408b-919a-4b8e6f0e1aa0&Name=Andreas%20Heissenberger&Standort=Wien%20(Bundesland)"
      }}>{`WKO Company Data`}</a>{`.`}</p>
    <h2>{`Contact Details`}</h2>
    <p><strong parentName="p">{`Company Name:`}</strong>{` Andreas Heissenberger`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Services:`}</strong>{` Digital Marketing & Digital Transformation`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Address:`}</strong>{` Horneckgasse 3, 1170 Wien`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Phone:`}</strong>{` ＋43‑664‑120‑7620`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Email:`}</strong>{` fragen`}{`­`}{`@`}{`­`}{`heissenberger.`}{`­`}{`at  `}</p>
    <h2>{`Company Data`}</h2>
    <p><strong parentName="p">{`Company Name:`}</strong>{` Andreas Heissenberger`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Description:`}</strong>{` Digital Marketing & Digital Transformation`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Founding Year:`}</strong>{`  1991 GmbH, 1994 KG, 2012 Einzelunternehmen`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Legal Form:`}</strong>{` Einzelunternehmen`}<br parentName="p"></br>{`
`}<strong parentName="p">{`GLN (ID public administration):`}</strong>{` 9110003233709`}<br parentName="p"></br>{`
`}<strong parentName="p">{`UID-Number:`}</strong>{` ATU67333334`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Other information according to §14 UGB:`}</strong>{` none`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Applicable legislation:`}</strong>{` none`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Other supervisory authority (according to ECG):`}</strong>{` none  `}</p>
    <h2>{`Disclosure according to media law`}</h2>
    <p><strong parentName="p">{`Media Owner:`}</strong>{` Andreas Heissenberger`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Head Office (place of main office):`}</strong>{` Wien`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Purpose of the company:`}</strong>{` Advertising Agency  `}</p>
    <h2>{`Permissions`}</h2>
    <p><a parentName="p" {...{
        "href": "https://www.wko.at/service/dienststelle.html?orgid=14713&_ga=2.71006416.1355841178.1588142777-1366709506.1588142777"
      }}>{`FG Advertising and Market Communication`}</a></p>
    <p><strong parentName="p">{`Advertising Agency`}</strong><br parentName="p"></br>{`
`}{`Since July 3rd, 2012 for the location`}<br parentName="p"></br>{`
`}{`1170 Wien, Horneckgasse 3`}<br parentName="p"></br>{`
`}{`Managing director under trade law: Andreas Heissenberger
Occupation: Advertising Agency  `}</p>
    <p><strong parentName="p">{`GISA-Zahl:`}</strong>{` 26538204`}</p>
    <p><strong parentName="p">{`Authority according to ECG (e-commerce law):`}</strong>{` Magistratisches Bezirksamt des XVII. Bezirkes`}</p>
    <h2>{`Information on online dispute resolution`}</h2>
    <p>{`Consumers can submit complaints to the EU's online dispute resolution platform: `}<a parentName="p" {...{
        "href": "https://ec.europa.eu/odr"
      }}>{`https://ec.europa.eu/odr`}</a>{`. You can also address any complaints to the email address above.`}</p>
    <h2>{`Disclaimer of liability`}</h2>
    <p>{`This disclaimer is to be regarded as part of the internet publication which you were referred from. If parts or individual formulations of this text should not, no longer or not completely comply with the applicable legal situation, the remaining parts of the document remain unaffected in their content and validity.`}</p>
    <h2>{`Liability for the content of this website`}</h2>
    <p>{`The content of this website was created with the greatest possible care. However, we assume no liability for the correctness, completeness and topicality of the content. As a service provider, we are responsible for our own content on these pages in accordance with general laws. However, we are not obliged to monitor transmitted or stored third-party information or to investigate circumstances that indicate illegal activity. Obligations to remove or block the use of information according to general laws remain unaffected. However, liability in this regard is only possible from the time we become aware of a specific legal violation. As soon as we become aware of such violations, we will remove this content immediately.`}</p>
    <h2>{`Liability for links to third party websites`}</h2>
    <p>{`Our offer contains links to external websites. We have no influence on the content of these external websites. For this reason, we cannot accept any liability for this external content. The respective provider or operator is always responsible for the content of the linked pages. The linked pages were checked for possible legal violations at the time the link was created. No illegal content was discernible at the time the link was created. A permanent control of the content of the linked pages is not reasonable without concrete evidence of an infringement. As soon as we become aware of legal violations, we will remove such links immediately.`}</p>
    <p>{`Version: 1.1.5 - 2020-05-07`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      